import {createContext, ReactNode, useEffect, useState} from 'react';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {fetchConfig} from 'shared/api/envConfig';
import {AppRouter} from './routes';
import {GlobalStyle} from './styles';

export type ConfigContextType = {
  VITE_AUTH_HOST: string;
  VITE_DADATA_TOKEN: string;
  VITE_SHARE_HOST: string;
  VITE_YANDEX_TOKEN: string;
  VITE_ADMIN_HOST: string;
  VITE_BEESHARE_HOST: string;
  [key: string]: any;
};

type ConfigContextProviderProps = {
  children: ReactNode;
};

const defaultConfigContext = {
  VITE_AUTH_HOST: '',
  VITE_DADATA_TOKEN: '',
  VITE_SHARE_HOST: '',
  VITE_YANDEX_TOKEN: '',
  VITE_ADMIN_HOST: '',
  VITE_BEESHARE_HOST: '',
};

export const ConfigContext = createContext<ConfigContextType>(defaultConfigContext);

const ConfigProvider = ({children}: ConfigContextProviderProps) => {
  const [configState, setConfigState] = useState<ConfigContextType | null>(null);
  useEffect(() => {
    if (!configState) {
      async function fetch() {
        const data = await fetchConfig();
        if (data) setConfigState(data);
      }
      fetch();
    }
  }, [configState]);

  if (!configState) return null;

  return <ConfigContext.Provider value={configState}>{children}</ConfigContext.Provider>;
};

function App() {
  return (
    <ConfigProvider>
      <GlobalStyle />
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <AppRouter />
    </ConfigProvider>
  );
}

export default App;
